module.exports = __webpack_public_path__ + "static/media/13ITC3.29658d24.jpg";